import React from 'react';
import { connect } from 'react-redux';
import { FieldArray, reduxForm } from 'redux-form';

import { CATEGORIES } from 'pages/create-activity/constants';

import {
  ExpansionPanelWrapper,
  CategoriesPrices,
  FormActionButtons
} from 'components';

import validate from './validate';

const initialValues = {
  days: []
};

const PricesDaily = ({
  handleSubmit,
  pricesDailyForm,
  setSubmitButton,
  isUpdate
  // selectedTabIndex
}) => {
  const getAvailableCategoriesNames = index => {
    const days = [...pricesDailyForm.values.days];
    const categories = days[index].categories.map(item => item.participant);
    return CATEGORIES.filter(x => !categories.includes(x));
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name="days"
          component={ExpansionPanelWrapper}
          isAddDeleteActions={false}
          getTitle={item => item.day}
          children={(field, index) => (
            <FieldArray
              name={`${field}.categories`}
              component={CategoriesPrices}
              availableCategories={getAvailableCategoriesNames(index)}
              tabName="price"
              tabNameAll="all prices"
              // selectedTabIndex={selectedTabIndex}
            />
          )}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  pricesDailyForm: state.form.pricesDailyForm
});

export default reduxForm({
  form: 'pricesDailyForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(mapStateToProps, null)(PricesDaily));
